import React from 'react'
import { IIconProps } from './Icon/Interfaces'

const SignalIcon = ({
  width=22,
  height=16,
  strokeColor='var(--blue)',
}: IIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 16"
      fill="none"
    >
      <path
        d="M6.04 14.662 4.721 16C2.242 14.044.668 11.189.668 8c0-3.19 1.573-6.045 4.054-8l1.317 1.337C3.972 2.967 2.66 5.347 2.66 8c0 2.652 1.313 5.031 3.38 6.662zM6.64 8c0-1.592.788-3.02 2.028-3.998L7.35 2.667C5.698 3.97 4.65 5.873 4.65 8c0 2.126 1.049 4.029 2.702 5.333l1.317-1.335C7.427 11.018 6.639 9.59 6.639 8zm13.37 0c0-2.653-1.314-5.032-3.381-6.663L17.946 0C20.426 1.955 22 4.81 22 8c0 3.189-1.573 6.044-4.054 8l-1.317-1.338c2.067-1.63 3.381-4.01 3.381-6.662zM14 11.998l1.317 1.335c1.653-1.304 2.702-3.207 2.702-5.333 0-2.127-1.049-4.03-2.702-5.333L14 4.002c1.24.978 2.028 2.406 2.028 3.998 0 1.591-.788 3.019-2.028 3.998zm-2.666-6.665a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334z"
        fill={strokeColor}
      />
    </svg>
  )
}

export default SignalIcon
